import Link from "next/link";

import styles from "./NotFound.module.css";

export const NotFound = () => {
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.header}>
          <Link href="/">
            <img src="/logo.svg" className={styles.logo} />
          </Link>
        </div>
      </div>
      <h1 className={styles.title}>404</h1>
      <p className={styles.subtitle}>Page not found</p>
    </div>
  );
};
